import { useEffect, useState } from "react";
import ConfirmActionModal from "../../components/AdminComponents/Modals/ConfirmActionModal";
import { addAlertType, getAllAlertTypes, toggleAlertTypeStatus, updateAlertType } from "../../services/AdminServices";
import AlertTypesList from "../../components/AdminComponents/PagesComponents/AlertTypes/AlertTypesList";
import AddAlertTypeModal from "../../components/AdminComponents/PagesComponents/AlertTypes/AddAlertTypeModal";
import MessageModal from "../../components/AdminComponents/Modals/MessageModal";


const AdminAlertTypePage = () => {

    const [editData, setEditData] = useState(null);
    const [openModal, setOpenModal] = useState(false);

    const [alertTypes, setAlertTypes] = useState([]);

    const [loading, setLoading] = useState(false);

    const [confirmModal, setConfirmModal] = useState({
        open: false,
        AlertType: null,
    });

    const [messageModal, setMessageModal] = useState({
        open: false,
        type: "success",
        title: "",
        message: "",
    });


    const showSuccess = (msg) => {
        setMessageModal({
            open: true,
            type: "success",
            title: "Success",
            message: msg,
        });
    };

    const showError = (msg) => {
        setMessageModal({
            open: true,
            type: "error",
            title: "Error",
            message: msg,
        });
    };

    const handleToggleRequest = (AlertType) => {
        setConfirmModal({ open: true, AlertType });
    };

    const handleConfirmToggle = async () => {
        try {
            await toggleAlertTypeStatus(confirmModal.AlertType.id);
            await loadAlertTypes();
            showSuccess(confirmModal.AlertType.active ? "AlertType deactivated successfully" : "AlertType activated successfully");
        } catch (err) {
            showError(err?.response?.data?.message || "Something went wrong");
        } finally {
            setConfirmModal({ open: false, AlertType: null });
        }
    };

    const loadAlertTypes = async () => {
        try {
            setLoading(true);
            const res = await getAllAlertTypes();
            if (res.success) {
                setAlertTypes(res.data);
            }

        } catch (err) {
            console.error(err?.response?.data?.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadAlertTypes();
    }, [])

    const handleSave = async (formData) => {
        try {
            console.log(formData);
            let res;
            if (editData) {
                res = await updateAlertType(editData.id, formData);
            } else {
                res = await addAlertType(formData);
            }

            if (res.success) {
                await loadAlertTypes();
                setOpenModal(false);
                setEditData(null);
                showSuccess(res.message);
            }
        } catch (err) {
            showError(err?.response?.data?.message || "Something went wrong");
        }
    }

    return (
         <div className="p-4 admin-card-box space-y-4">
            <div className="flex justify-between items-center">
                <h2 className="admin-heading text-blue">Alert Types</h2>
                <button
                    className="btnAdd"
                    onClick={() => {
                        setEditData(null);
                        setOpenModal(true);
                    }}
                >
                    + Add Alert Type
                </button>
            </div>
            <AlertTypesList
                data={alertTypes}
                loading={loading}
                onEdit={(d) => {
                    setEditData(d);
                    setOpenModal(true);
                }}
                onToggle={handleToggleRequest}
            />

            <AddAlertTypeModal
                open={openModal}
                editData={editData}
                onClose={() => {
                    setOpenModal(false);
                    setEditData(null);
                }}
                onSave={handleSave}
            />


            <ConfirmActionModal
                open={confirmModal.open}
                title={
                    confirmModal.AlertType?.active
                        ? "Deactivate Work Type"
                        : "Activate Work Type"
                }
                message={
                    confirmModal.AlertType?.active
                        ? "Do you really want to deactivate this alert type?"
                        : "Do you want to activate this alert type again?"
                }
                confirmText={
                    confirmModal.AlertType?.active ? "DEACTIVATE" : "ACTIVATE"
                }
                onConfirm={handleConfirmToggle}
                onClose={() =>
                    setConfirmModal({ open: false, AlertType: null })
                }
            />

            <MessageModal
                open={messageModal.open}
                type={messageModal.type}
                title={messageModal.title}
                message={messageModal.message}
                onClose={() =>
                    setMessageModal({ ...messageModal, open: false })
                }
            />


        </div>
    )
}

export default AdminAlertTypePage;
